import { render, staticRenderFns } from "./RewardDonutChart.vue?vue&type=template&id=37d37531&scoped=true"
import script from "./RewardDonutChart.vue?vue&type=script&lang=js"
export * from "./RewardDonutChart.vue?vue&type=script&lang=js"
import style0 from "./RewardDonutChart.vue?vue&type=style&index=0&id=37d37531&prod&scoped=true&lang=css"
import style1 from "./RewardDonutChart.vue?vue&type=style&index=1&id=37d37531&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d37531",
  null
  
)

export default component.exports